'use strict';

export const isValidDate = function (val) {
    // Validate date. (some browser sees ex: 202011-01-01 as a valid date)
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    return val.match(regEx) != null;
};